import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Carousel } from 'antd';
import { conservationImages } from 'assets/media/home';
import ScrollableItem from 'components/sharedComponents/ScrollableItem';
import styles from './Conservation.module.scss';

interface ConservationSlide {
  title: string;
  subTitle: string;
}

const Conservation: FC = () => {
  const { t } = useTranslation();
  const { innerWidth: width } = window;

  const slides = t('pages.home.conservationCarousel', {
    returnObjects: true,
  }) as unknown as ConservationSlide[];

  return (
    <div className={styles.Container}>
      <Row justify="center">
        <Col lg={12} md={14} xs={20} className={styles.TitleContainer}>
          <h1 className={styles.Title}>{t('pages.home.conservationTitle')}</h1>
          <p className={styles.SubTitle}>{t('pages.home.conservationSubTitle')}</p>
        </Col>
      </Row>
      <div className={styles.ScrollableList}>
        <Carousel
          dots={{ className: styles.Dots }}
          slidesToShow={width > 768 ? 3 : 1}
          draggable
          swipeToSlide
          touchThreshold={50}
          focusOnSelect
          autoplay
        >
          {slides.map(({ title, subTitle }, index) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <div key={`slide_${index}`}>
                <ScrollableItem
                  scrollableImageClassName={styles.ScrollableImage}
                  imageUrl={conservationImages[index]}
                  title={title}
                  subTitle={subTitle}
                />
              </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};

export default Conservation;
